import { enqueueSnackbar } from 'notistack';

const BRANCH_COOKIE = 'branch';

export const getCurrentBranch = (): string | null => {
  const match = document.cookie.split('; ').find(row => row.startsWith(`${BRANCH_COOKIE}=`));
  if (!match) return null;
  const value = match.slice(BRANCH_COOKIE.length + 1);
  return value ? decodeURIComponent(value) : null;
};

export const setBranchCookie = (branch: string, availableBranches: string[]): boolean => {
  if (!availableBranches.includes(branch)) {
    enqueueSnackbar(`Branch "${branch}" was not found`, { variant: 'error' });
    return false;
  }
  document.cookie = `${BRANCH_COOKIE}=${encodeURIComponent(branch)}; path=/`;
  return true;
};

export const clearBranchCookie = (): void => {
  document.cookie = `${BRANCH_COOKIE}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
